<template>
  <div v-if="!lock">
    <div class="list-container">

      <router-link v-for="(k, i) in data" :key="i" :to="{name:'KidsInfo', params:{code:k.code}}">
        <div class="icon-container">
          <div class="child-icon">
            <i class="far fa-child" :class="kidsColor(k.sex)"></i>
          </div>
          <div class="text">{{k.name}}</div>
          <div class="pay-text"><img src="/images/icn_paycoin.svg">{{k.payInfo.pay}}<span class="pay">ペイ</span></div>
        </div>
      </router-link>

      <KidsAdd v-if="isIcon" :viewMode="isIcon"/>

    </div>

  </div>
</template>

<script>

import KidsAdd from '@/components/project/KidsAdd';

export default {
  components: {
    KidsAdd
  },
  data () {
    return {
      store: 'kids',
      lock: false,
      data: {},
    };
  },
  created: function () {
    this.initialize();
  },
  watch: {
    '$route' () {
      this.initialize();
    },
    lock: function () {
      // ローディング表示
      if (this.lock === true) {
        this.$store.dispatch('loading/open').then();
      } else {
        this.$store.dispatch('loading/close').then();
      }
    },
    callbackDispatcher: function () {
      console.log(this.callbackDispatcher);

      if (this.callbackDispatcher === 'Add-Kids-Finish') {
        this.list();
      } else if (this.callbackDispatcher === 'KidsListUpdate') {
        this.list();
      }
    }
  },
  computed: {
    callbackDispatcher: function () {
      return this.$store.getters['message/callback'];
    },
    isIcon: function () {

      if (Object.keys(this.data).length === 0) {
        return true;
      } else {
        return false;
      }
    }
  },
  methods: {
    initialize: function () {

      this.list();

    },
    list: function () {

      if (this.lock === true) {
        // console.log('lock', this.lock);
        return;
      }

      let params = {
        s: this.$store.getters['auth/session']
      };
      // console.log(params);

      // ロック
      this.lock = true;

      let dispatch = this.store + '/list';

      this.$store.dispatch(dispatch, params).then(() => {

        // ロック解除
        this.lock = false;

        let status = this.$store.getters[this.store + '/status'];

        if (status === 200) {

          this.data = this.$store.getters[this.store + '/list'];

          this.$emit('loaded');

        } else {
          this.$store.dispatch('errorInfo/setErrorStore', this.store).then();
          this.$router.push({name: 'UserSystemError'});
        }

      }).catch((err) => {
        console.warn(err);

        // ロック解除
        this.lock = false;

        this.$store.dispatch('errorInfo/setSystemErrorMessage').then();
        this.$router.push({name: 'UserSystemError'});
      });
    },
    kidsColor: function (sex) {

      if(sex === 1){
        return 'boy';
      } else if(sex === 2){
        return 'girl';
      } else{
        return 'default';
      }
    }

  }
};

</script>

<style lang="scss" scoped>

  @import '../../assets/styles/_variable.scss';

  .boy {
    color: #95DFD6;
  }

  .girl {
    color: #F3C0AB;
  }

  .default {
    color: #f7d08a;
  }

  .pay{
    padding-top: 8px;
    padding-left: 4px;
    font-size: 13px;
  }

  // 801以上
  @media screen and (min-width: 801px) {

    .list-container {

      display: flex;
      flex-wrap: wrap;
      justify-content: center;

      .icon-container {

        background: #fff;
        border: 1px solid $keyColor;
        border-radius: 10px;
        margin: 5px;

        width: 250px;
        height: 260px;
        font-size: 150px;
        text-align: center;
      }

      .text {
        font-size: 22px;
        text-align: center;
      }

      .pay-text {
        font-size: 20px;
        text-align: center;
        color: $keyColor;
        display: flex;
        align-items: center;
        justify-content: center;

        img {
          margin-right: 5px;
        }
      }

    }

    .detail {

      .title {
        font-size: 16px;
        border-bottom: 1px solid #ddd;
      }

      .date {
        padding-top: 10px;
        font-size: 13px;
      }

      .body {
        padding: 10px 0 0 20px;
        white-space: pre-wrap;
      }
    }

  }

  // 800まで
  @media screen and (max-width: 800px) {

    .list-container {

      width: 100%;

      .icon-container {
        background: #fff;
        border: 1px solid $keyColor;
        border-radius: 15px;
        margin: 5px;
        text-align: center;
        padding: 20px;

        .child-icon{
          font-size: 100px;
          line-height: 100px;
        }
      }

      .text {
        font-size: 22px;
        text-align: center;
      }

      .pay-text {
        font-size: 20px;
        text-align: center;
        color: $keyColor;
        display: flex;
        align-items: center;
        justify-content: center;

        img {
          margin-right: 5px;
        }
      }

    }

    .detail {

      .title {
        font-size: 16px;
        border-bottom: 1px solid #ddd;
      }

      .date {
        padding-top: 10px;
        font-size: 13px;
      }

      .body {
        padding: 10px 0 0 20px;
        white-space: pre-wrap;
      }
    }

  }

</style>
